import React from 'react';

import PropTypes from 'prop-types';
import Nav from 'react-bootstrap/Nav';
import { withRouter } from 'react-router-dom';

import CartModal from '@src/components/cart/CartModal';

class CartMenuItem extends React.PureComponent {
    static propTypes = {
        displayName: PropTypes.string,
        onShow: PropTypes.func,
        cartItemsData: PropTypes.shape({
            loaded: PropTypes.string.isRequired,
            cartItems: PropTypes.arrayOf(PropTypes.shape({
                id: PropTypes.number.isRequired,
                title: PropTypes.string,
                image: PropTypes.object,
                // eslint-disable-next-line camelcase
                updated_at: PropTypes.string,
            })),
        }),
        history: PropTypes.shape({
            push: PropTypes.func.isRequired,
        }).isRequired,
        location: PropTypes.shape({
            hash: PropTypes.string,
        }).isRequired,
    };

    constructor(props) {
        super(props);
        // eslint-disable-next-line react/state-in-constructor
        this.state = {
            showModal: false,
        };
    }

    componentDidUpdate(prevProps) {
        if (this.state.showModal) {
            return;
        }

        if (!this.props.location.hash.includes('#cart')) {
            return;
        }

        if (prevProps.cartItemsData === this.props.cartItemsData) {
            return;
        }

        this.setState({ showModal: true });
    }

    handleClick = (e) => {
        e.preventDefault();

        this.setState({ showModal: true });

        if (this.props.onShow) {
            this.props.onShow();
        }
    };

    closeModal = () => {
        this.setState({ showModal: false });
    };

    handleEsc = (e) => {
        if (e.key === 'Escape') {
            this.closeModal();
        }
    };

    handleSubmit = (id, uuid) => {
        this.closeModal();
        this.props.history.push(`/checkout/${id}?uuid=${uuid}`);
    };

    renderModal = () => {
        if (!this.state.showModal) {
            return null;
        }

        const { cartItemsData } = this.props;

        return (
            <CartModal
                cartItemsData={cartItemsData}
                onClose={this.closeModal}
                onSubmit={this.handleSubmit}
            />
        );
    };

    render() {
        const { displayName, cartItemsData } = this.props;

        const isFilled = cartItemsData && cartItemsData.cartItems?.length > 0;
        let cartImgSrc = '/img/icons/shopping-bag.svg';
        if (isFilled) {
            cartImgSrc = '/img/icons/shopping-bag-a.svg';
        }

        return (
            <>
                <Nav.Item className="cart-menu-item">
                    <Nav.Link
                        className="cart-icon"
                        title={displayName}
                        tabIndex={1000}
                        onClick={this.handleClick}
                    >
                        <img src={cartImgSrc} alt="cart" />
                    </Nav.Link>
                </Nav.Item>
                { this.renderModal() }
            </>
        );
    }
}

export default withRouter(CartMenuItem);
